module.exports = __webpack_public_path__ + "static/media/book-circle-active.d2469517.svg";